import { ActionTypes } from "@/App/constants/actionTypes";
import { PlanTypes } from "@/types";

type GetPlan = {
  type: typeof ActionTypes.GET_PLAN;
  payload: { id: string };
};

export const getPlan = (id: string): GetPlan => {
  return {
    type: ActionTypes.GET_PLAN,
    payload: { id },
  };
};

type GetPlanFailure = {
  type: typeof ActionTypes.GET_PLAN_FAILURE;
};

export const getPlanFailure = (): GetPlanFailure => {
  return {
    type: ActionTypes.GET_PLAN_FAILURE,
  };
};

type GetPlanSuccess = {
  type: typeof ActionTypes.GET_PLAN_SUCCESS;
  payload: PlanTypes.Plan;
};

export const getPlanSuccess = (data: PlanTypes.Plan): GetPlanSuccess => {
  return {
    type: ActionTypes.GET_PLAN_SUCCESS,
    payload: data,
  };
};

export type PlanGetActions = GetPlan | GetPlanFailure | GetPlanSuccess;
